"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FileInputField", {
  enumerable: true,
  get: function get() {
    return _FileInputField["default"];
  }
});
exports["default"] = void 0;

var _FileInputField = _interopRequireWildcard(require("../FileInputField"));

/**
 * DEPRECATED - only exists for backwards compatibility
 */
var _default = _FileInputField.FileInput;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/FileInput.js
// module id = 519
// module chunks = 0